import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    close: 'Close',
    discover: 'Discover',
    text: 'Up to {amount} of referral',
  },
  fr: {
    close: 'Fermer',
    discover: 'Découvrir',
    text: 'Jusqu’à {amount}\nde parrainage',
  },
} as const);

export default locales;
